export enum EAppointmentType {
  /** First contact with a student who has no coach yet — one calendar block. */
  Intro = 1,
  /** Regular meeting with an assigned student — two calendar blocks. */
  Regular = 2,
}
